import { Component } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public appPages = [
    { title: 'Inicio', url: '/orders-summary', icon: 'home-outline' },
    { title: 'Menú de artículos', url: '/articles', icon: 'fast-food-outline' },
    { title: 'Historial de Pedidos', url: '/history', icon: 'menu-outline' },
    { title: 'Mi cuenta', url: '/my-account', icon: 'person-outline' },
  ];

  constructor(
    public authService: AuthService
  ) { }

}
